import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

function salesDifferenceRequestBody(args, thunkAPI) {
  const {
    p1From,
    p1To,
    p2From,
    p2To,
    branche_ids = [],
    product_ids = [],
    foodDeliveryApp = 0,
    workTime = "all",
    valueType = "total",
    atvEnabled = false,
    viewType = "all",
    includeAllBranches = false,
  } = args;
  const state = thunkAPI.getState();
  let posIds = branche_ids;
  if (branche_ids.length > 0) {
    if (state.POSBranches?.status !== "succeeded") {
      return { error: "branches_not_loaded" };
    }
    const wanted = branche_ids.map(Number);
    const matchedChildren = (state.POSBranches?.rows || []).flatMap(
      (group) =>
        group.children?.filter((child) => wanted.includes(child.realId)) || []
    );
    posIds = matchedChildren
      .map((child) => Number(child.res_branch_id))
      .filter(Boolean);
    if (posIds.length === 0) {
      return { error: "branches_not_loaded" };
    }
  }
  return {
    body: {
      p1_from: p1From,
      p1_to: p1To,
      p2_from: p2From,
      p2_to: p2To,
      branche_ids: posIds,
      product_ids,
      foodDeliveryApp: Number(foodDeliveryApp) || 0,
      workTime,
      valueType,
      atvEnabled,
      viewType,
      includeAllBranches: Boolean(includeAllBranches),
    },
  };
}

function rejectSalesDifference(error, thunkAPI) {
  const data = error.response?.data;
  return thunkAPI.rejectWithValue(data?.code || data?.detail || error.message);
}

export const fetchSalesDifference = createAsyncThunk(
  "api/salesDifference/fetch",
  async (args, thunkAPI) => {
    try {
      const prepared = salesDifferenceRequestBody(args, thunkAPI);
      if (prepared.error) return thunkAPI.rejectWithValue(prepared.error);
      const response = await api.post("/api/SalesDifference", prepared.body);
      return response.data;
    } catch (error) {
      return rejectSalesDifference(error, thunkAPI);
    }
  }
);

export const fetchSalesDifferenceExclusions = createAsyncThunk(
  "api/salesDifference/exclusions",
  async (args, thunkAPI) => {
    try {
      const prepared = salesDifferenceRequestBody(args, thunkAPI);
      if (prepared.error) return thunkAPI.rejectWithValue(prepared.error);
      const response = await api.post(
        "/api/SalesDifferenceExclusions",
        prepared.body
      );
      return response.data;
    } catch (error) {
      return rejectSalesDifference(error, thunkAPI);
    }
  }
);

const salesDifferenceSlice = createSlice({
  name: "salesDifference",
  initialState: { result: null, status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesDifference.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSalesDifference.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchSalesDifference.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default salesDifferenceSlice.reducer;

export const selectSalesDifferenceResult = (state) => state.salesDifference.result;
export const selectSalesDifferenceStatus = (state) => state.salesDifference.status;
export const selectSalesDifferenceError = (state) => state.salesDifference.error;
